import { Outlet } from 'react-router-dom'

export const handle = {
  title: `PMS Schedules`,
  breadcrumb: `PMS Schedules`,
}

export default function ProviderSchedules(): React.ReactElement {
  return <Outlet />
}
